var _circle, _path, _path2, _path3, _rect, _rect2, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBandwidth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36.5,
    r: 36.5,
    fill: "#E8F6F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37 26.1123C37 26.1123 45.5 20.1116 55 26.1123",
    stroke: "#159082",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30.1113C40 30.1113 45.4545 25.6113 52 30.1113",
    stroke: "#159082",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22.1108C35 22.1108 45.5 15.1113 57 22.1108",
    stroke: "#159082",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 40.1113,
    width: 36,
    height: 13,
    rx: 3,
    fill: "#159082",
    stroke: "#159082",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 33.1113,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#159082"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 46.6113,
    r: 3,
    fill: "#159082",
    stroke: "#E8F6F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 46.6113,
    r: 3,
    fill: "#159082",
    stroke: "#E8F6F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBandwidth);
export default __webpack_public_path__ + "static/media/bandwidth.daee51b3cca57929d779b16ebf3018fa.svg";
export { ForwardRef as ReactComponent };